import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    IconButton,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

// import Logo from "./media/img/CRS_PFP.jpg";// adjust this path
// import Logo from "./media/img/AEROSOC.png";
import Logo from "./media/img/AEROSOC.svg";

const menuItems = [
    { label: "Home", link: "/" },
    { label: "Events", link: "/events" },
    { label: "About Us", link: "/about" },
    { label: "Join Us", link: "/join" },
];
const Header = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const isMobile = useMediaQuery("(max-width:900px)");

    return (
        <AppBar
            position="static"
            color="transparent"
            elevation={0}
            sx={{
                // borderBottom: "1px solid #ddd",
                p:2
            }}
        >
            <Toolbar disableGutters sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                {/* Mobile Drawer */}
                <Drawer
                    anchor="left"
                    open={drawerOpen}


                    onClose={() => setDrawerOpen(false)}
                >
                    <Box

                        sx={{ width: 250, paddingTop: 2 }}
                        role="presentation"
                        onClick={() => setDrawerOpen(false)}
                    >
                        <List>
                            {menuItems.map((item,v) => (
                                <ListItemButton key={item.label} href={item.link}>
                                    <ListItemText
                                        primary={item.label}
                                        primaryTypographyProps={{
                                            fontSize: "1.1rem",
                                            fontWeight: 600,
                                        }}
                                    />
                                </ListItemButton>
                            ))}


                        </List>
                    </Box>
                    {/* Logo inside drawer */}
                    <Box
                        component="img"
                        src={Logo}
                        alt="Society Logo"
                        sx={{
                            height: 90,
                            width: "auto",
                            display: "block",
                            margin: "20px auto 0",
                        }}
                    />
                </Drawer>
                {/* Title */}
                {/* Desktop vs Mobile */}
                {isMobile ? (
                    <IconButton onClick={() => setDrawerOpen(true)} aria-label="menu">
                        <MenuIcon />
                    </IconButton>
                ) : (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3,  }}>

                        {menuItems.map((item) => (
                            <Typography
                                key={item.label}
                                variant="button"
                                onClick={() => window.location.href = item.link}
                                sx={{
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    color: "#333",
                                    fontSize: {
                                        xl: 16
                                    },
                                    "&:hover": { color: "primary.main",
                                        transform: "scale(1.15)",
                                        transition: "transform 0.15s ease-in-out",

                                    },
                                }}
                            >
                                {item.label}
                            </Typography>
                        ))}


                    </Box>

                )}
                <Typography

                    variant="h2"
                    component="h1"
                    sx={{
                        fontWeight: "bold",
                        letterSpacing: 0.5,
                        color: "#000",
                        textAlign: "center",
                        paddingTop: 0,
                        typography: {
                            xs: "h6",
                            sm: "h5",
                            md: "h4",
                            lg: "h4",
                            xl: "h2",
                        },
                        // improve default font size for certain sizes
                        "@media (min-width:900px) and (max-width:1050px)": {
                            fontSize: "clamp(1.6rem, 1.7rem, 2.0rem)",
                        },
                    }

                }
                >

                    City St George Aerospace Society
                </Typography>

                <Box
                    component="img"
                    src={Logo}
                    alt="Society Logo"
                    sx={{
                        height: { xs: 80, sm: 90, md: 110, lg: 120, xl: 130 },
                        width: "auto",
                        objectFit: "contain",
                    }}
                />
            </Toolbar>

        </AppBar>
    );
};

export default Header;